// ============================================================
// I-ACE CHAPTER 4 — CENTRAL EVENT CONFIGURATION
// Edit this file to update registration links, committees,
// schedule, stats and contact details. Nothing else needs to change.
// ============================================================

export const MAIN_REGISTRATION_FORM = "https://forms.gle/8sYZps7jFdyp92YB6";

// Individual committee registration links — replace per committee later.
export const COMMITTEE_REGISTRATION_FORMS = {
    LOK_SABHA: "https://forms.gle/8sYZps7jFdyp92YB6",
    AIPPM: "https://forms.gle/8sYZps7jFdyp92YB6",
    UPLA: "https://forms.gle/8sYZps7jFdyp92YB6",
    UNCSW: "https://forms.gle/8sYZps7jFdyp92YB6",
    UNHRC: "https://forms.gle/8sYZps7jFdyp92YB6",
    NMC: "https://forms.gle/8sYZps7jFdyp92YB6",
    IP: "https://forms.gle/8sYZps7jFdyp92YB6",
    IPL_AUCTION: "https://forms.gle/8sYZps7jFdyp92YB6",
};

// Official event dates — confirmed by the Secretariat.
// Opening ceremony time is assumed (09:00 IST) — update when confirmed.
export const EVENT = {
    dates: "8–9 October 2026",
    openingDate: "8 October 2026",
    openingCeremonyISO: "2026-10-08T09:00:00+05:30",
};

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/committees", label: "Committees" },
    { to: "/schedule", label: "Schedule" },
];

// Full mobile menu — every major section, in order.
export const MENU_ITEMS = [
    { label: "Home", to: "/" },
    { label: "About I-ACE", to: "/#about" },
    { label: "Forums", to: "/#forums" },
    { label: "Committees", to: "/#committees" },
    { label: "Secretariat", to: "/#secretariat" },
    { label: "Schedule", to: "/#schedule" },
    { label: "Gallery", to: "/gallery" },
    { label: "Brochure", to: "/#brochure" },
    { label: "Previous Editions", to: "/#previous-editions" },
];

// Secretariat — add members as they are announced:
// { name: "Full Name", designation: "Role", photo: "/images/secretariat/name.jpg" }
// "placeholders" controls how many empty portrait frames show while a tier is empty.
export const SECRETARIAT_TIERS = [
    {
        id: "sg",
        title: "Secretary-General",
        placeholders: 1,
        members: [
            {
                name: "Ayush Kumar Yadav",
                designation: "Secretary-General",
                photo: "/images/secretariat/ayush.jpg",
            },
        ],
    },
    {
        id: "dg",
        title: "Director General",
        placeholders: 1,
        members: [
            {
                name: "Arnav Singh Koushal",
                designation: "Director General",
                photo: "/images/secretariat/arnav.jpg",
            },
        ],
    },
    {
        id: "dsg",
        title: "Deputy Secretary-General",
        placeholders: 1,
        members: [
            {
                name: "Riddhi Sharma",
                designation: "Deputy Secretary-General",
                photo: "/images/secretariat/riddhi.jpg",
            },
        ],
    },
    {
        id: "organising",
        title: "Organising Committee",
        placeholders: 1,
        members: [
            {
                name: "Ananya Dwivedi",
                designation: "Organising Committee Head",
                photo: "/images/secretariat/ananya.jpg",
            },
        ],
    },
];

export const STATS = [
    { value: "700+", label: "Participants" },
    { value: "8", label: "Committees & Events" },
    { value: "₹1.6L", label: "Cash Prizes · ₹20K per Committee" },
    { value: "BHU", label: "Banaras Hindu University" },
];

export const PORTFOLIO_MATRIX_URL =
    "https://docs.google.com/spreadsheets/d/1f3QqkniqhRvfQEzA0ZjHmsZFxxWn4fFpgMcRzspqWJo/edit?usp=drivesdk";

export const BROCHURE_URL = "/I-ACE-4.0-Brochure.pdf";

// Previous editions gallery — drop photos into /public/images/gallery/
// and list them here: { src: "/images/gallery/photo.jpg", caption: "Opening Ceremony", edition: "Chapter 3" }
export const GALLERY_IMAGES = [
    {
        src: "/images/gallery/winners-trophy.jpg",
        caption: "Winners lift the trophy",
        edition: "Awards · Previous Edition",
        category: "Awards",
    },
    {
        src: "/images/gallery/grand-house.jpg",
        caption: "Floor to balcony, a packed house",
        edition: "Previous Edition",
        category: "Previous Editions",
    },
    {
        src: "/images/gallery/full-voice.jpg",
        caption: "A floor in full voice",
        edition: "Previous Edition",
        category: "Committees",
    },
    {
        src: "/images/gallery/lok-sabha-placard.jpg",
        caption: "Placards rise in the house",
        edition: "Lok Sabha · Previous Edition",
        category: "Youth Parliament",
    },
    {
        src: "/images/gallery/press-at-work.jpg",
        caption: "The press at work",
        edition: "IP · Previous Edition",
        category: "Committees",
    },
    {
        src: "/images/gallery/between-sessions.jpg",
        caption: "Delegates between sessions",
        edition: "Previous Edition",
        category: "Committees",
    },
    {
        src: "/images/gallery/seminar-hall.jpg",
        caption: "Every seat taken",
        edition: "Previous Edition",
        category: "Previous Editions",
    },
    {
        src: "/images/gallery/school-outreach.jpg",
        caption: "Outreach at DALIMSS Sunbeam Global School",
        edition: "The One Percent Club",
        category: "Campus",
    },
    {
        src: "/images/gallery/in-session.jpg",
        caption: "The house, in session",
        edition: "Previous Edition",
        category: "Previous Editions",
    },
    {
        src: "/images/gallery/foundation-day.jpg",
        caption: "4th Foundation Day celebrations",
        edition: "The One Percent Club",
        focus: "object-bottom",
        category: "Campus",
    },
    {
        src: "/images/gallery/thumbs-up.jpg",
        caption: "All smiles, all thumbs up",
        edition: "The One Percent Club",
        category: "Campus",
    },
    {
        src: "/images/gallery/outreach.jpg",
        caption: "An outreach session with young delegates",
        edition: "The One Percent Club",
        category: "Campus",
    },
];

// Canonical category order — filter tabs appear only for categories that have photos.
export const GALLERY_CATEGORIES = [
    "MUN",
    "Youth Parliament",
    "Committees",
    "Secretariat",
    "Awards",
    "Campus",
    "Previous Editions",
];

const AWARDS = [
    { title: "Best Delegation", amount: "₹10,000" },
    { title: "High Commendation", amount: "₹6,000" },
    { title: "Special Mention", amount: "₹3,000" },
    { title: "Honourable Mention", amount: "₹1,000" },
];

const TBA = {
    executiveBoard: "Executive Board to be announced.",
};

export const COMMITTEES = [
    {
        id: "lok-sabha",
        key: "LOK_SABHA",
        name: "Lok Sabha",
        logo: "/images/committees/lok-sabha.webp",
        short: "The lower house of Indian democracy — legislation, debate and the will of the people.",
        about: "A simulation of the lower house of the Indian Parliament, where delegates step into the shoes of elected representatives to debate and shape legislation.",
        agenda: "This House deliberates upon the regulation of social media platforms, with special emphasis on combating misinformation and hate speech while safeguarding freedom of expression and individual privacy.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "aippm",
        key: "AIPPM",
        name: "AIPPM",
        logo: "/images/committees/aippm.webp",
        short: "All India Political Parties Meet — a national dialogue across party lines.",
        about: "The All India Political Parties Meet brings rival ideologies to one table, forcing consensus on questions that shape the nation.",
        agenda: "This House deliberates upon the future of India's reservation policy, with special emphasis on social justice, equitable representation, and meritocracy.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "upla",
        key: "UPLA",
        name: "UPLA",
        logo: "/images/committees/upla.webp",
        short: "The Uttar Pradesh Legislative Assembly — the state's law, order and justice on the floor of the House.",
        about: "A simulation of the Uttar Pradesh Legislative Assembly, bringing the state's most pressing questions of policy, governance and public security to the floor of the House.",
        agenda: "This House deliberates upon whether Uttar Pradesh's stringent law-and-order policies have enhanced justice or compromised constitutional safeguards, with special emphasis on due process and public security.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "uncsw",
        key: "UNCSW",
        name: "UNCSW",
        logo: "/images/committees/uncsw.webp",
        short: "The UN Commission on the Status of Women — equality, rights and representation.",
        about: "The United Nations Commission on the Status of Women deliberates on gender equality, rights and representation across the globe.",
        agenda: "Deliberation on Traditional and Cultural Practices Affecting Women's Rights with Special Emphasis on Balancing Cultural Sovereignty with Universal Human Rights.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "unhrc",
        key: "UNHRC",
        name: "UNHRC",
        logo: "/images/committees/unhrc.webp",
        short: "The UN Human Rights Council — dignity, justice and fundamental freedoms.",
        about: "The United Nations Human Rights Council debates violations, protections and the future of fundamental freedoms worldwide.",
        agenda: "Deliberation on Human Rights in Occupied Territories with Special Emphasis on Accountability for Violations of International Humanitarian Law, Protection of Civilians, and the Responsibilities of Occupying Powers.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "nmc",
        key: "NMC",
        name: "NMC",
        logo: "/images/committees/nmc.webp",
        short: "The exclusive committee — Nehru, Indira Gandhi, Vajpayee and Modi at one table.",
        about: "The exclusive committee of I-ACE Chapter 4 — a chamber where India's Prime Ministers across eras, from Jawaharlal Nehru and Indira Gandhi to Atal Bihari Vajpayee and Narendra Modi, sit at one table and debate the defining questions of the nation.",
        agenda: "Deliberation on the Evolution of Executive Power in sovereign India, with special emphasis on the balance between strong leadership, democratic institutions, and constitutional accountability.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "ip",
        key: "IP",
        name: "IP",
        logo: "/images/committees/ip.webp",
        short: "The press contingent — chronicling every motion, speech and vote.",
        about: "The press contingent of I-ACE — journalists and chroniclers who document every motion, speech and vote.",
        agenda: "Agenda to be announced.",
        awards: AWARDS,
        ...TBA,
    },
    {
        id: "ipl-auction",
        key: "IPL_AUCTION",
        name: "IPL Auction",
        monogram: "IPL",
        short: "Bid. Strategise. Build the dream squad — ₹3,000 per team.",
        about: "A live IPL-style mock auction at I-ACE Chapter 4 — franchises bid, strategise and build the strongest squad under a fixed purse. Registration is per team: ₹3,000.",
        agenda: "A live player auction — franchise strategy, bidding wars and squad building under a fixed purse.",
        portfolioText: "Team registration — ₹3,000 per team. Squad rules and the player pool are shared with registered teams.",
        awards: [
            { title: "Winner", amount: "₹10,000" },
            { title: "Runner-up", amount: "₹6,000" },
            { title: "2nd Runner-up", amount: "₹4,000" },
        ],
    },
];

export const COMMITTEE_GROUPS = [
    { id: "mun", title: "Model United Nations", committeeIds: ["uncsw", "unhrc"] },
    { id: "youth", title: "Youth Parliament / Indian Forum", committeeIds: ["lok-sabha", "aippm", "upla"] },
    { id: "press", title: "The Press", committeeIds: ["ip"] },
    { id: "exclusive", title: "The Exclusive Committee", committeeIds: ["nmc"] },
    { id: "special", title: "Special Events", committeeIds: ["ipl-auction"] },
];

export const SCHEDULE_DAYS = [
    {
        id: "day-1",
        day: "Day 1",
        date: "Thursday · 8 October 2026",
        tagline: "Debate. Discuss. Draft.",
        items: [
            { time: "TBA", title: "Registration", note: "Delegate check-in and kit distribution." },
            { time: "TBA", title: "Opening Ceremony", note: "Inauguration of I-ACE Chapter 4." },
            { time: "TBA", title: "Committee Session I", note: "" },
            { time: "TBA", title: "Lunch", note: "" },
            { time: "TBA", title: "Committee Session II", note: "" },
            { time: "TBA", title: "Special Session / Networking", note: "" },
        ],
    },
    {
        id: "day-2",
        day: "Day 2",
        date: "Friday · 9 October 2026",
        tagline: "Deliberate. Decide. Deliver.",
        items: [
            { time: "TBA", title: "Committee Session III", note: "" },
            { time: "TBA", title: "Final Deliberations", note: "Resolutions, drafts and closing debates." },
            { time: "TBA", title: "Awards Ceremony", note: "Recognising the finest delegates of Chapter 4." },
            { time: "TBA", title: "Closing Ceremony", note: "The gavel falls on I-ACE Chapter 4." },
        ],
    },
];

// Official contact details.
export const CONTACT = {
    phones: ["7905281982", "9431874967"],
    email: "theonepercentbhu@gmail.com",
    socials: [
        {
            label: "Instagram",
            value: "@theonepercent_bhu",
            href: "https://www.instagram.com/theonepercent_bhu?igsi=MWczMW9yOTMxZ2I0cw==",
        },
        {
            label: "LinkedIn",
            value: "The One Percent Club, BHU",
            href: "https://www.linkedin.com/company/the-1percent-club-bhu/",
        },
        { label: "YouTube", value: "To be updated", href: null },
    ],
};

// Executive boards — keyed by committee "key".
export const EXECUTIVE_BOARDS = {
    LOK_SABHA: [
        { role: "Speaker", name: "Shaurya Singh Pundir" },
        { role: "Deputy Speaker", name: "Vishal Anand Jha" },
        { role: "Political Advisor", name: "Akshat Singh" },
    ],
    AIPPM: [
        { role: "Co-Moderator", name: "Shreyas Shivam" },
        { role: "Co-Moderator", name: "Tanmay Gaur" },
        { role: "Political Advisor", name: "Mudit Bhati" },
    ],
    UPLA: [
        { role: "Speaker", name: "Adarsh Tiwari" },
        { role: "Deputy Speaker", name: "Akanksha Singh" },
        { role: "Deputy Speaker", name: "Shreya Upadhyay" },
        { role: "Political Advisor", name: "Ashwini Kumar Mishra" },
    ],
    NMC: [
        { role: "Speaker", name: "Shubham Tripathi" },
        { role: "Deputy Speaker", name: "Anurag Vashu" },
        { role: "Deputy Speaker", name: "Shashwat Tiwari" },
        { role: "Political Advisor", name: "Aditi Singh" },
    ],
    UNHRC: [
        { role: "Chairperson", name: "Niharika Jaiswal" },
        { role: "Vice-Chairperson", name: "Yenan Varghese" },
        { role: "Rapporteur", name: "Stuti Singh" },
    ],
    UNCSW: [
        { role: "Chairperson", name: "Palak Singh" },
        { role: "Vice-Chairperson", name: "Anurag Pandey" },
        { role: "Rapporteur", name: "Ujjwal Kumar Nath" },
    ],
    IP: [
        { role: "Editor-in-Chief", name: "Ipshita Shukla" },
        { role: "Head of Photography", name: "Poshika" },
    ],
    IPL_AUCTION: [
        { role: "Auctioneer", name: "Mrinal Verma" },
        { role: "Auctioneer", name: "Abhishek Rai" },
    ],
};
